<xemex-dialog-shell
  [title]="'installations.attributes.meterRole.dialog.title' | translate: { ldn: data.ldn }"
>
  <div class="flex flex-col gap-4">
    <p class="m-0 text-text-secondary">
      {{
        'installations.attributes.meterRole.dialog.current'
          | translate
            : {
                role: 'meterRoles.' + data.current | translate,
                origin: 'installations.attributes.meterRole.origin.' + data.origin | translate,
              }
      }}
    </p>

    @if (data.otherInstallations !== 0) {
      <xemex-alert-banner variant="warning" data-testid="shared-device">
        {{
          (data.otherInstallations === null
            ? 'installations.attributes.sharedDevice.unknown'
            : data.otherInstallations === 1
              ? 'installations.attributes.sharedDevice.one'
              : 'installations.attributes.sharedDevice.many'
          ) | translate: { count: data.otherInstallations }
        }}
      </xemex-alert-banner>
    }

    <mat-radio-group
      class="flex flex-col gap-2"
      [attr.aria-label]="'installations.attributes.meterRole.label' | translate"
      [value]="selected()"
      (change)="select($event.value)"
    >
      @for (role of roles; track role) {
        <mat-radio-button
          class="rounded-lg border border-border-default p-2"
          [value]="role"
          [attr.data-testid]="'meter-role-' + role"
        >
          <span class="flex items-center gap-2 py-1">
            <mat-icon class="text-text-muted">{{ icons[role] }}</mat-icon>
            <span class="flex flex-col">
              <span class="text-sm font-medium">{{ 'meterRoles.' + role | translate }}</span>
              <span class="text-xs text-text-secondary">
                {{ 'meterRoles.descriptions.' + role | translate }}
              </span>
            </span>
          </span>
        </mat-radio-button>
      }
    </mat-radio-group>

    <p class="m-0 text-sm text-text-secondary" data-testid="rebind-note">
      {{ 'installations.attributes.meterRole.dialog.rebind' | translate }}
    </p>

    @if (refusal(); as refused) {
      <p class="m-0 text-text-error" role="alert">{{ refused.messageKey | translate }}</p>
    }
  </div>

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button [disabled]="!canSave()" [loading]="isSaving()" (click)="save()">
      {{ 'general.btnSave' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
